module.exports = __webpack_public_path__ + "static/img/menu5.a8009b67.png";